import classNames from "classnames"

export const MapFooterBaseMapRow = ({
    title,
    thumbnailSrc,
    isSelected,
    onClick,
}: {
    title: string
    thumbnailSrc: string
    isSelected: boolean
    onClick: () => void
}) => (
    <div
        className="h-12 flex items-center gap-3 px-4 py-2 cursor-pointer select-none hover:bg-gray-700"
        onClick={onClick}
    >
        <div className="w-6 h-5 flex items-center justify-center shrink-0">
            <div
                className={classNames(
                    "w-5 h-5 rounded-full border flex items-center justify-center",
                    {
                        "border-gray-50 bg-gray-700": isSelected,
                        "border-gray-100 bg-gray-800": !isSelected,
                    }
                )}
            >
                {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-blue-500" />}
            </div>
        </div>
        <img
            src={thumbnailSrc}
            alt={title}
            className={classNames(
                "w-8 h-8 rounded-lg shadow-[0_1px_2px_0_rgba(12,12,15,0.95)] shrink-0",
                { "border border-blue-500": isSelected }
            )}
        />
        <span className={classNames("text-sm", isSelected ? "text-white" : "text-gray-100")}>
            {title}
        </span>
    </div>
)
